<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-done`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 2a2 2 0 012 2v40.628a2 2 0 01-2.959 1.755L24.959 38.69a2 2 0 00-1.918 0L8.959 46.383A2 2 0 016 44.628V4a2 2 0 012-2h32zm-2 4H10v35.256l11.123-6.077a6 6 0 015.754 0L38 41.256V6zm-4.808 9.665l-1.414-1.415a1 1 0 00-1.414 0l-7.778 7.778-3.536-3.535a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l5.657 5.657a1 1 0 001.414 0l9.9-9.9a1 1 0 000-1.413z"/></svg>
</template>
<script>

export default {
  name: 'IconDone',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
